import { getPublicPara, urlList, setFace } from '../../api/api'
import axios from 'axios'
import { baseUrlApi, resCode } from '../../api/common'
const face = {
  state: {
    face: null
  },
  mutations: {
    FACE (state, info) {
      if (info) {
        state.face = info
      } else {
        state.face = null
      }
    }
  },
  getters: {
    face: state => state.face
  },
  actions: {
    async FACE ({ commit, state }, payload) {
      if (!state.face) {
        const faceOptions = {
          method: 'post',
          url: baseUrlApi + '/' + urlList.queryFace,
          data: getPublicPara(),
          json: true
        }
        faceOptions.data.user_id = payload.userInfo
        const faceImg = await axios(faceOptions)

        if (faceImg) {
          if (faceImg.data.code === resCode.OK) {
            let face = ''
            if (faceImg.data.list.length > 0) {
              face = faceImg.data.list[0]
            }
            setFace(JSON.stringify(face))
            commit('FACE', JSON.stringify(face))
          }
        }
      }
    }
  }
}

export default face
